<template>
  <SidbearSettingsGroup
    title="Type Animation"
    beta
  >
    <editor-menu-bar
      v-if="editor"
      v-slot="{ getMarkAttrs, isActive, commands }"
      :editor="editor"
    >
      <div>
        <div
          v-if="!hasSelected"
          class="mt-2"
        >
          Select text to animate
        </div>

        <div v-else>
          <b-btn
            v-if="!isActive.typed()"
            variant="primary"
            @click="() => setup(commands)"
          >
            Add Effect
          </b-btn>

          <typed-animation-controls
            v-else
            :commands="commands"
            :get-mark-attrs="getMarkAttrs('typed')"
            :is-active="isActive.typed()"
            :editor="editor"
          />
        </div>
      </div>
    </editor-menu-bar>
  </SidbearSettingsGroup>
</template>

<script>
import SidbearSettingsGroup from '@/components/editor/components/SidbearSettingsGroup'
import TypedAnimationControls from '@/components/editor/components/TypedAnimationControls'

const EditorMenuBar = {
  name: 'EditorMenuBarCompat',
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  render () {
    const editor = this.editor

    if (!editor) {
      return null
    }

    const baseCommands = editor.commands || {}

    // Прокси для commands: сначала берём из editor.commands, иначе пытаемся через chain().focus()[name]()
    const commands = new Proxy(baseCommands, {
      get (target, key) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
          const commandFn = target[key]
          if (typeof commandFn === 'function') {
            return (...args) => commandFn(...args)
          }
        }

        return (...args) => {
          const chain = editor.chain().focus()
          if (typeof chain[key] === 'function') {
            return chain[key](...args).run()
          }
          return null
        }
      }
    })

    const isActive = new Proxy({}, {
      get (_target, key) {
        return (attrs) => editor.isActive(key, attrs)
      }
    })

    const getMarkAttrs = (name) => {
      try {
        return editor.getAttributes(name) || {}
      } catch (e) {
        return {}
      }
    }

    const slot = this.$scopedSlots.default

    if (!slot) {
      return null
    }

    const children = slot({
      editor,
      commands,
      isActive,
      getMarkAttrs,
      getNodeAttrs: getMarkAttrs
    })

    return Array.isArray(children) ? children[0] : children
  }
}

export default {
  name: 'TypeAnimationSettings',
  components: { TypedAnimationControls, SidbearSettingsGroup, EditorMenuBar },
  props: {
    editor: {
      type: Object,
      default: null
    },
    sid: {
      type: String,
      required: true
    }
  },
  computed: {
    hasSelected () {
      if (!this.editor || !this.editor.state || !this.editor.state.selection) return false
      const { selection } = this.editor.state
      return !selection.empty
    }
  },
  methods: {
    setup (commands) {
      if (!this.editor || !this.editor.state || !this.editor.state.selection) return

      const { selection } = this.editor.state
      if (selection.empty) return

      const { from, to } = selection
      const selectedText = this.editor.state.doc.textBetween(from, to)
      if (!selectedText) return

      commands.typed({ words: `<span>${selectedText}</span>`, backspeed: 70, speed: 70, fade: false })
    }
  }
}
</script>
